var heading_default = {
  "fontElementMap": "puHXE",
  "elementSpacing": "KmcSt",
  "headerOne": "_15c07 KmcSt",
  "headerTwo": "HaW-p KmcSt",
  "headerThree": "hBahk KmcSt",
  "headerFour": "_66-Mp KmcSt",
  "headerFive": "qlKGn KmcSt",
  "headerSix": "mYzeQ KmcSt",
  "child": "Xiplu"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
